<script>
  import { onMount } from "svelte";
  import {
    API_DIR,
    SESSION_LS,
    USERNAME_LS,
    selectedDevices,
    selectedPage,
    tableData,
    COMPANY_LS
  } from "../store";
  import { toasts } from "svelte-toasts";
  import { each } from "svelte/internal";
  import { getRandString } from "../Utils.svelte";

  let selectedDeviceObj;
  let dbConfigFiles = [];

  //let uniqueFirmwares = getFirmwareList();
  let sortedDevices = {};
  let configSelection = {};
  let currUnixDate = new Date().getTime();
  let groupTagInputPlaceholder = `campaign-${localStorage.getItem(
    $USERNAME_LS
  )}-${new Date().toISOString().slice(0, 10)}`;
  let groupTagInput = groupTagInputPlaceholder;

  const actTypeEnum = {
    LMU: "LMU",
    JPOD: "JPOD",
    JPOD2: "JPOD2"
  };

  const tooltipForceUpdateText =
    "If enabled, the update will be forced on the device. This will ignore the current firmware/config version and update the device with the selected firmware or config. Otherwise, the device will only be updated if the current firmware/config version is different from the one selected.";

  let updatesGroups = {};
  $: updatesGroups, console.log("UPDATES GROUP", updatesGroups);
  $: groupTagInput, console.log("GROUP TAG", groupTagInput);

  function sortDevices() {
    $selectedDevices.forEach((device) => {
      if (sortedDevices[device.app] == undefined) {
        sortedDevices[device.app] = {};
      }

      if (sortedDevices[device.app][device.app_id] == undefined) {
        sortedDevices[device.app][device.app_id] = [];
      }

      let vbusJpod;
      if (device.hasOwnProperty("VBUS")) {
        let vbus;

        vbus = device.VBUS.split(",");

        if (vbus[0] == "1") {
          vbusJpod = actTypeEnum.JPOD;
        }

        if (vbus[0] == "8") {
          vbusJpod = actTypeEnum.JPOD2;
        }
      } else {
        vbusJpod = "None";
      }
      if (sortedDevices[device.app][device.app_id][vbusJpod] == undefined) {
        sortedDevices[device.app][device.app_id][vbusJpod] = [];
      }

      sortedDevices[device.app][device.app_id][vbusJpod].push(device);
    });
  }

  function filterCompatibleFwByAppId(appId, firmwareData, jpod) {
    const compatibleFiles = [];
    const company = JSON.parse(localStorage.getItem($COMPANY_LS)); //list of companies

    //console.log("USER COMPANY", company);

    for (const file of firmwareData) {
      //console.log("FILE COMPANY", file.company);

      let isCompanyFile = false;

      if (file.company && company) {
        try {
          isCompanyFile = company.some((element) =>
            file.company.includes(element)
          );
        } catch (error) {
          console.log(error);
        }
      }

      // Reemplaza la condición
      if (
        company == '"admin"' ||
        company == "admin" ||
        (file.company && isCompanyFile)
      ) {
        console.log("Is company file", isCompanyFile);

        let app_id;
        const type = file.type;

        if (file.hasOwnProperty("app_id")) {
          app_id = file.app_id;
        } else {
          app_id = file.compatible_app_id;
        }

        if (!actTypeEnum.hasOwnProperty(jpod)) {
          if (type != actTypeEnum.JPOD && type != actTypeEnum.JPOD2) {
            if (app_id.includes(appId)) {
              compatibleFiles.push(file);
            }
          }
        } else if (actTypeEnum.hasOwnProperty(jpod)) {
          if (type == jpod || type == actTypeEnum.LMU) {
            if (app_id.includes(appId)) {
              compatibleFiles.push(file);
            }
          }
        }
      }
    }

    return compatibleFiles;
  }

  async function fetchConfigData() {
    try {
      const response = await fetch(`${$API_DIR}/api/v1/get-all-files`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        }
      });
      if (response.status === 401) {
        location.reload();
      }
      if (!response.ok) {
        throw new Error(
          "Error al obtener los archivos de configuración y firmware"
        );
      }
      let data = await response.json();
      //console.log(data);
      //console.log("Compatible appId", isAppIdCompatible(selectedDeviceObj,data));

      if (data.length < 1) {
        alert("No Config Files with compatible AppId and Firmware Found");
        selectedPage.set(1);
        return [];
      } else if (data.length > 0) {
        return data;
      } else {
        alert("No Config Files Found");
        selectedPage.set(1);
        return [];
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  async function updateDeviceGroup(firmware, appId, jpod) {
    let forceUpdate = document.getElementById(
      `force-update-${firmware}-${appId}-${jpod}`
    ).checked;

    let statusContainer = document.getElementById(
      `config-content-${firmware}-${appId}-${jpod}`
    );

    console.log("searching for:", `config-title-${firmware}-${appId}-${jpod}`);

    let titleContainer = document.getElementById(
      `config-title-${firmware}-${appId}-${jpod}`
    );

    statusContainer.innerHTML = ""; // Limpiamos el contenido anterior
    titleContainer.innerHTML = `Updates: <span id="updates-success-${firmware}-${appId}-${jpod}">0</span> uploaded, <span id="updates-failed-${firmware}-${appId}-${jpod}">0</span> failed`;

    let succesCounter = parseInt(
      document.getElementById(`updates-success-${firmware}-${appId}-${jpod}`)
        .innerText
    );

    let failedCounter = parseInt(
      document.getElementById(`updates-failed-${firmware}-${appId}-${jpod}`)
        .innerText
    );

    for (const device of sortedDevices[firmware][appId][jpod]) {
      let randId = getRandString(20);
      let groupLenght =
        updatesGroups[`${firmware}-${appId}-${jpod}`].queue.length;

      for (const [index, task] of updatesGroups[
        `${firmware}-${appId}-${jpod}`
      ].queue.entries()) {
        if (task.value != -1) {
          //console.log("Task", task);
          let responseCode;

          if (forceUpdate) {
            if (task.filetype == "firmware") {
              responseCode = await updateDeviceFirmware(
                device.id_device, //deviceId
                device.app_id, //appId
                task.version, //updatedFirmware
                task.filename, //filename
                device.imsi, //imsi
                task.auth, //auth
                task.type, //type,
                index,
                randId,
                groupLenght
              );
            } else if (task.filetype == "config") {
              responseCode = await updateDeviceConfig(
                device.id_device, //DeviceId
                task.version, //updatedVersion
                device.app_id, //updateAppId
                task.update_firmware, //updateFW
                task.filename, //filename
                task.type, //type
                device.imsi, //imsi
                task.auth, //auth
                index,
                randId,
                groupLenght
              );
            }
          } else {
            if (task.filetype == "firmware") {
              if (device.app != task.update_firmware) {
                responseCode = await updateDeviceFirmware(
                  device.id_device, //deviceId
                  device.app_id, //appId
                  task.version, //updatedFirmware
                  task.filename, //filename
                  device.imsi, //imsi
                  task.auth, //auth
                  task.type, //type,
                  index,
                  randId,
                  groupLenght
                );
              } else {
                responseCode = 201;
              }
            } else if (task.filetype == "config") {
              if (device.config != task.version) {
                responseCode = await updateDeviceConfig(
                  device.id_device, //DeviceId
                  task.version, //updatedVersion
                  device.app_id, //updateAppId
                  task.update_firmware, //updateFW
                  task.filename, //filename
                  task.type, //type
                  device.imsi, //imsi
                  task.auth, //auth
                  index,
                  randId,
                  groupLenght
                );
              } else {
                responseCode = 201;
              }
            }
          }

          let listItem = document.createElement("div");
          listItem.className = "alert";

          if (responseCode === 200) {
            listItem.classList.add("alert-success");
            listItem.innerHTML = `<i class="bi bi-check-square-fill"></i> <strong>${device.id_device}:</strong> Update in process!`;
            succesCounter++;
          } else if (responseCode === 201) {
            listItem.classList.add("alert-success");
            listItem.innerHTML = `<i class="bi bi-exclamation-triangle-fill"></i> <strong>${device.id_device}:</strong> No update needed.`;
          } else {
            listItem.classList.add("alert-danger");
            listItem.innerHTML = `<i class="bi bi-x-square-fill"></i> <strong>${device.id_device}:</strong> Update Error.`;
            failedCounter++;
          }

          titleContainer.innerHTML = `Updates: <strong><span class="text-success" id="updates-success-${firmware}-${appId}-${jpod}">${succesCounter}</span></strong> uploaded, <strong><span id="updates-failed-${firmware}-${appId}-${jpod}">${failedCounter}</span></strong> failed.`;
          statusContainer.appendChild(listItem);
        }
      }
    }
  }

  async function updateDeviceFirmware(
    deviceId,
    appId,
    updatedFirmware,
    filename,
    imsi,
    auth,
    type,
    index,
    randId,
    groupLenght
  ) {
    if (
      deviceId != undefined &&
      updatedFirmware != undefined &&
      filename != undefined &&
      type != undefined &&
      randId != undefined
    ) {
      const url = `${$API_DIR}/api/v1/upload-firmware-update`;
      const campaignName =
        groupTagInput == "" || groupTagInput == undefined
          ? "campaign"
          : groupTagInput;
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        },
        body: JSON.stringify({
          device_id: deviceId,
          app_id: appId,
          updated_firmware: updatedFirmware,
          filename: filename,
          imsi: imsi,
          auth: auth,
          type: type,
          tag_group: campaignName,
          id_group: randId,
          //id_group: `${campaignName}-${currUnixDate}`,
          index: index,
          group_lenght: groupLenght
        })
      };

      try {
        const response = await fetch(url, requestOptions);

        if (response.status == 401) {
          location.reload();
        } else if (!response.ok) {
          return response.status;
        } else {
          return response.status;
        }
      } catch (error) {
        //alert("Error: " + error.message);
        console.log("Error:", error);
        return 500;
      }
    } else {
      //alert("Invalid Selection");
      return -1;
    }
  }

  async function updateDeviceConfig(
    deviceId,
    updatedVersion,
    updateAppId,
    updateFW,
    filename,
    type,
    imsi,
    auth,
    index,
    randId,
    groupLenght
  ) {
    if (
      configSelection != -1 &&
      deviceId != undefined &&
      updateAppId != undefined &&
      updateFW != undefined &&
      filename != undefined &&
      type != undefined &&
      randId != undefined
    ) {
      const url = `${$API_DIR}/api/v1/upload-config-update`;
      const campaignName =
        groupTagInput == "" || groupTagInput == undefined
          ? "campaign"
          : groupTagInput;
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        },
        body: JSON.stringify({
          device_id: deviceId,
          version: updatedVersion,
          app_id: updateAppId,
          filename: filename,
          firmware: updateFW,
          type: type,
          imsi: imsi,
          auth: auth,
          tag_group: campaignName,
          id_group: randId,
          index: index,
          group_lenght: groupLenght
        })
      };

      try {
        const response = await fetch(url, requestOptions);

        if (response.status == 401) {
          location.reload();
        } else if (!response.ok) {
          return response.status;
        } else {
          return response.status;
        }
      } catch (error) {
        //alert("Error: " + error.message);
        console.log("Error:", error);
        return 500;
      }
    } else {
      //alert("Invalid Selection");
      return -1;
    }
  }

  function addSelectionRow(firmware, appId, jpod) {
    let newObj = Object.assign({}, updatesGroups);

    if (!newObj[`${firmware}-${appId}-${jpod}`]) {
      //console.log("creating");
      newObj[`${firmware}-${appId}-${jpod}`] = {
        firmware: firmware,
        app_id: appId,
        jpod: jpod,
        toalTasks: 1,
        queue: [
          {
            value: "invalid"
          }
        ]
      };
    } else {
      //console.log("pushing");
      newObj[`${firmware}-${appId}-${jpod}`].queue.push({
        value: "invalid"
      });
    }

    updatesGroups = Object.assign({}, newObj);

    return "";
  }

  function removeTask(firmware, appId, jpod, index) {
    let newObj = Object.assign({}, updatesGroups);

    console.log("Seraching", `${firmware}-${appId}-${jpod}`);
    console.log("found", newObj[`${firmware}-${appId}-${jpod}`]);

    if (newObj[`${firmware}-${appId}-${jpod}`]) {
      console.log("RECIEVED INDEX", index);
      const queue = newObj[`${firmware}-${appId}-${jpod}`].queue;

      if (index >= 0 && index < queue.length) {
        console.log("Removing", index);
        console.log("data", queue[index]);

        queue.splice(index, 1);
      }
    }

    updatesGroups = Object.assign({}, newObj);
  }

  sortDevices();
  console.log(sortedDevices);

  onMount(async () => {
    dbConfigFiles = await fetchConfigData();

    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    //console.log(dbConfigFiles);
  });
</script>

<div>
  <hr />
  <div class="d-flex justify-content-between">
    <h3>Create Tasks Queue</h3>

    <button
      type="button"
      class="btn btn-outline-danger"
      style="margin-right: 12px;"
      on:click={() => {
        selectedPage.set(3);
      }}><i class="bi bi-x-square" /> Close</button
    >
  </div>

  <br />

  <div class="input-group mb-3">
    <span class="input-group-text" id="basic-addon3">GROUP TAG:</span>
    <input
      type="text"
      class="form-control"
      id="group-tag-input"
      placeholder={groupTagInputPlaceholder}
      bind:value={groupTagInput}
      aria-describedby="basic-addon3"
      maxlength="50"
    />
  </div>

  <hr />

  <!--contenedores de devices-->

  {#each Object.keys(sortedDevices) as firmware}
    {#each Object.keys(sortedDevices[firmware]) as appId}
      {#each Object.keys(sortedDevices[firmware][appId]) as jpod}
        <div class="row" style="max-height: 500px;">
          <div
            class="col-md-6 border border-1 rounded m-2 p-2"
            style="border-color: #C6C7C8; max-height:inherit;"
          >
            <h5>
              Firmware: <strong>{firmware}</strong> / {Object.keys(
                sortedDevices[firmware][appId][jpod]
              ).length}
              {Object.keys(sortedDevices[firmware][appId][jpod]).length == 1
                ? "Device"
                : "Devices"} / JPOD: {jpod}
            </h5>
            <hr />
            <div class="table-container">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="header">Device Id</th>
                    <th scope="col" class="header">App Id</th>
                    <th scope="col" class="header">Firmware</th>
                    <th scope="col" class="header">Script</th>
                    <th scope="col" class="header">Config</th>
                  </tr>
                </thead>
                <tbody class="tbody-scroll">
                  {#each sortedDevices[firmware][appId][jpod] as device}
                    <tr>
                      <td>{device.id_device}</td>
                      <td>{device.app_id}</td>
                      <td>{device.app}</td>
                      <td>{device.script}</td>
                      <td>{device.config}</td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
          </div>

          <div
            class="col-md border border-1 rounded m-2 p-2"
            style="border-color: #C6C7C8; max-height:inherit"
          >
            <div
              id="config-version-selector-{firmware}-{appId}-{jpod}"
              style="overflow:auto;max-height: 100%; height:100%;"
            >
              <div>
                <h5 id="config-title-{firmware}-{appId}-{jpod}">
                  <div class="d-flex justify-content-between">
                    <div>Tasks</div>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="force-update-{firmware}-{appId}-{jpod}"
                      />
                      <label
                        class="form-check-label"
                        for="force-update-{firmware}-{appId}-{jpod}"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={tooltipForceUpdateText}
                      >
                        Force Update
                      </label>
                    </div>
                  </div>
                </h5>
                <hr />

                <div
                  id="config-content-{firmware}-{appId}-{jpod}"
                  style="margin: 8px;"
                >
                  {#if (dbConfigFiles.length > 0) & (filterCompatibleFwByAppId(appId, dbConfigFiles, jpod).length > 0)}
                    {addSelectionRow(firmware, appId, jpod)}

                    {#if updatesGroups[`${firmware}-${appId}-${jpod}`]}
                      {#each updatesGroups[`${firmware}-${appId}-${jpod}`].queue as row, index}
                        <div
                          id="task-content-{firmware}-{appId}-{jpod}-{index}"
                          style="margin: 8px;"
                        >
                          <div
                            id="taskStepContent-{firmware}-{appId}-{jpod}-{index}"
                            class="d-flex"
                            style="margin-bottom: 12px;"
                          >
                            <!--<div
                              class="btn btn-secondary"
                              style="margin-right: 8px; cursor: default; pointer-events: none;"
                              hidden={index !==
                                updatesGroups[`${firmware}-${appId}-${jpod}`]
                                  .queue.length -
                                  1}
                            >-->
                            <div
                              class="btn btn-secondary"
                              style="margin-right: 8px; cursor: default; pointer-events: none;"
                            >
                              {index + 1}#
                            </div>

                            <select
                              class="form-select flex-fill"
                              id="taskSelection-{firmware}-{appId}-{jpod}-{index}"
                              on:change={(event) => {
                                const selectedValue = JSON.parse(
                                  event.target.value
                                );
                                updatesGroups[
                                  `${firmware}-${appId}-${jpod}`
                                ].queue[index] = {
                                  value: 1,
                                  update_firmware: firmware,
                                  app_id: appId,
                                  version: selectedValue.version,
                                  filename: selectedValue.filename,
                                  type: selectedValue.type,
                                  auth: selectedValue.auth,
                                  filetype: selectedValue.filetype
                                };
                              }}
                              disabled={index !==
                                updatesGroups[`${firmware}-${appId}-${jpod}`]
                                  .queue.length -
                                  1}
                            >
                              {#if updatesGroups[`${firmware}-${appId}-${jpod}`].queue.length == 1 || index == 0}
                                <option value="-1">Select a file...</option>
                                {#each filterCompatibleFwByAppId(appId, dbConfigFiles, jpod) as option}
                                  <option
                                    value={JSON.stringify(option)}
                                    selected={updatesGroups[
                                      `${firmware}-${appId}-${jpod}`
                                    ].queue[index].value === option.filename}
                                  >
                                    {option.filename} | {option.filetype} | {option.type}
                                  </option>
                                {/each}
                              {:else}
                                <option value="-1">Select a file...</option>
                                {#each filterCompatibleFwByAppId(updatesGroups[`${firmware}-${appId}-${jpod}`].queue[index - 1].app_id, dbConfigFiles, updatesGroups[`${firmware}-${appId}-${jpod}`].queue[index - 1].jpod) as option}
                                  <option
                                    value={JSON.stringify(option)}
                                    selected={updatesGroups[
                                      `${firmware}-${appId}-${jpod}`
                                    ].queue[index].value === option.filename}
                                  >
                                    {option.filename} | {option.filetype} | {option.type}
                                  </option>
                                {/each}
                              {/if}
                            </select>

                            <button
                              id="removeTask-{firmware}-{appId}-{jpod}-{index}"
                              type="button"
                              class="btn btn-outline-danger"
                              style="margin-left: 8px;"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Remove task from queue"
                              on:click={() => {
                                console.log("Removing task at index:", index);
                                removeTask(firmware, appId, jpod, index);
                              }}
                              hidden={index !==
                                updatesGroups[`${firmware}-${appId}-${jpod}`]
                                  .queue.length -
                                  1}><i class="bi bi-dash-circle" /></button
                            >
                          </div>
                        </div>
                      {/each}
                    {/if}

                    <div class="" style="margin-bottom: 12px">
                      <div class="d-flex justify-content-end">
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          style="margin-right: 8px;"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Add task to queue"
                          on:click={async () => {
                            //await updateDeviceGroup(firmware, appId, jpod);
                            addSelectionRow(firmware, appId, jpod);
                          }}
                          disabled={updatesGroups[
                            `${firmware}-${appId}-${jpod}`
                          ]?.queue.length > 0 &&
                            updatesGroups[`${firmware}-${appId}-${jpod}`].queue[
                              updatesGroups[`${firmware}-${appId}-${jpod}`]
                                .queue.length - 1
                            ].value == "invalid"}
                          ><i class="bi bi-plus-circle" />
                        </button>

                        <br />
                        <br />

                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          on:click={async () => {
                            await updateDeviceGroup(firmware, appId, jpod);
                          }}
                          hidden={updatesGroups[`${firmware}-${appId}-${jpod}`]
                            ?.queue.length === 0}
                          disabled={updatesGroups[
                            `${firmware}-${appId}-${jpod}`
                          ]?.queue.length > 0 &&
                            updatesGroups[`${firmware}-${appId}-${jpod}`].queue[
                              updatesGroups[`${firmware}-${appId}-${jpod}`]
                                .queue.length - 1
                            ].value == "invalid"}
                          ><i class="bi bi-arrow-up-square" /> Update</button
                        >
                      </div>
                    </div>
                  {:else}
                    <h4>No updates available.</h4>
                  {/if}
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
      {/each}
    {/each}
  {/each}
</div>

<style>
  .table-container {
    overflow: hidden; /* Oculta el desplazamiento vertical en el contenedor */
    max-height: 90%;
    overflow: auto;
  }

  .table-container table {
    width: 100%;
    table-layout: fixed; /* Asegura que la tabla ocupe el ancho completo del contenedor */
  }

  .table-container .tbody-scroll {
    max-height: calc(
      100% - 37px
    ); /* Establece la altura máxima del tbody (altura del contenedor - altura del encabezado) */
    overflow-y: auto; /* Agrega un desplazamiento vertical solo al tbody si el contenido excede la altura máxima */
  }

  .header {
    position: sticky;
    top: 0;
  }
</style>
